export enum EStorageName {
  Token = 'token',
}
